import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

import cardBg from '../../../assets/img/about/aboutFour/image2.webp';

const valueCards = [
  { className: "card1", titleKey: "about_four_card1_title", textKey: "about_four_card1_text" },
  { className: "card2", titleKey: "about_four_card2_title", textKey: "about_four_card2_text" },
  { className: "card3", titleKey: "about_four_card3_title", textKey: "about_four_card3_text" },
  { className: "card4", titleKey: "about_four_card4_title", textKey: "about_four_card4_text" },
  { className: "card5", titleKey: "about_four_card5_title", textKey: "about_four_card5_text" },
  { className: "card6", titleKey: "about_four_card6_title", textKey: "about_four_card6_text" },
];

function AboutFour() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <div className="aboutFour">
      <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
        <div>
          <div className="aboutFourTitle">
            <h1 className={`${isVisible ? 'visible' : ''}`}>{t("about_four_title")}</h1>
          </div>
          <div className="aboutFourContent1">
            <div className={`card1 card ${isVisible ? 'visible' : ''}`}>
              <img src={cardBg} alt="" width={'300px'} />
              <div className="cardText">
                <h2>{t("about_four_mission")}</h2>
                <p>{t("about_four_mission_text")}</p>
              </div>
            </div>
            <div className={`card2 card ${isVisible ? 'visible' : ''}`}>
              <img src={cardBg} alt="" width={'150px'} />
              <div className="cardText">
                <h2>{t("about_four_values")}</h2>
              </div>
            </div>
            <div className={`card3 card ${isVisible ? 'visible' : ''}`}>
              <img src={cardBg} alt="" width={'300px'} />
              <div className="cardText">
                <h2>{t("about_four_vision")}</h2>
                <p>{t("about_four_vision_text")}</p>
              </div>
            </div>
          </div>
          <Swiper
            breakpoints={{
              0:    { slidesPerView: 1 },
              768:  { slidesPerView: 2 },
              1000: { slidesPerView: 3 },
              1600: { slidesPerView: 4 },
            }}
            slidesPerView={4}
            spaceBetween={30}
            className={`${isVisible ? 'visible' : ''}`}
            modules={[Autoplay]}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
          >
            {valueCards.map(({ className, titleKey, textKey }) => (
              <SwiperSlide key={className}>
                <div className={`card ${className} ${isVisible ? 'visible' : ''}`}>
                  <h2>{t(titleKey)}</h2>
                  <div className="underline"></div>
                  <p>{t(textKey)}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </VisibilitySensor>
    </div>
  );
}

export default AboutFour;
